import { createTheme } from '@mui/material/styles';

const MuiTheme = createTheme({
  palette: {
    primary: {
      main: '#2b60f6',
      dark: '#141B45',
    },
  },
  typography: {
    fontFamily: 'Noto Sans, sans-serif',
    textTransform: 'none',
    button: {
      textTransform: 'none',
    },
  },
});

export default MuiTheme;
